export async function nominatimSearch(address, country = "my", timeoutMs = 8000) {
    const q = address.trim();
    if (!q)
        return null;
    const url = new URL("https://nominatim.openstreetmap.org/search");
    url.searchParams.set("q", q);
    url.searchParams.set("format", "json");
    url.searchParams.set("limit", "1");
    if (country)
        url.searchParams.set("countrycodes", country);
    try {
        const r = await fetch(url.toString(), { headers: { Accept: "application/json" }, signal: AbortSignal.timeout(timeoutMs) });
        if (!r.ok)
            return null;
        const arr = (await r.json());
        if (!arr.length)
            return null;
        return { lat: parseFloat(arr[0].lat), lng: parseFloat(arr[0].lon), displayName: arr[0].display_name };
    }
    catch {
        return null;
    }
}
/**
 * Nominatim's free-text search is strict: a valid address with a building/mall name or many comma-separated parts often returns nothing.
 * Retry with the leading segments dropped one by one, down to "postcode city, state". `approximate` is true when a shorter variant matched
 * (coarser than a street-level fix) so the caller can ask the person to check the map before trusting it.
 */
export async function geocodeWithFallback(address, country = "my", search = nominatimSearch) {
    const segments = address.split(",").map((s) => s.trim()).filter(Boolean);
    for (let i = 0; i < segments.length; i++) {
        if (i > 0)
            await new Promise((r) => setTimeout(r, 1100)); // 1 request/second
        const hit = await search(segments.slice(i).join(", "), country);
        if (hit)
            return { ...hit, approximate: i > 0 };
    }
    return null;
}
//# sourceMappingURL=geocode.js.map